import React from 'react';

type BookingStatus = 'confirmed' | 'pending' | 'cancelled' | 'checked-in' | 'checked-out';

const statusConfig: Record<BookingStatus, { label: string; className: string }> = {
  confirmed: { label: 'Confirmed', className: 'bg-green-100 text-green-700' },
  pending: { label: 'Pending', className: 'bg-amber-100 text-amber-700' },
  cancelled: { label: 'Cancelled', className: 'bg-red-100 text-red-700' },
  'checked-in': { label: 'Checked In', className: 'bg-blue-100 text-blue-700' },
  'checked-out': { label: 'Checked Out', className: 'bg-gray-100 text-gray-600' },
};

export default function StatusBadge({ status }: { status: BookingStatus }) {
  const config = statusConfig[status];
  return (
    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-600 ${config.className}`}>
      {config.label}
    </span>
  );
}